import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {OverlayService} from "../../features/home/service/OverlayService";

export default function AuthWrapper({ children }) {
  const location = useLocation();
  const navigate = useNavigate();

 const checkUserToken = async () => {
     try {
       const response = await OverlayService.valiToken();
       console.log('checkUserToken:', response.data.success);
       if(response.status === 200){ // true if token exists
        return response.data.success;
       }else{
        return false;
       }
     } catch (err) {
       console.error('Error fetching insights:', err);
       return false; // treat errors as no token
     }
   };
 

  useEffect(() => {
    const publicRoutes = ["/login", "/"]; // Add more public routes if needed

    const executeAuthCheck = async () => {
      const tokenExists = await checkUserToken();

      if (location.pathname === "/login" && tokenExists && localStorage.getItem("user")) {
        // Redirect logged-in user away from login
        navigate("/home", { replace: true });
        return;
      }

      if (!publicRoutes.includes(location.pathname) && !tokenExists) {
        // Redirect unauthenticated user to login
        localStorage.clear();
        sessionStorage.clear();
        navigate("/login", { replace: true });
        return;
      }
    };

    executeAuthCheck();

  }, [location, navigate]);

  return children;
}
